import React from 'react'
import { useAppSelector } from '../../../store/hooks'
import { selectAccountId } from '../../../store/auth/authSlice'
import { useGetMeQuery } from '../../../store/user/user'

interface AgentIntroProps {
  introText: string
}

export const AgentIntro: React.FC<AgentIntroProps> = ({ introText }) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: currentUser } = useGetMeQuery({ accountId })

  return (
    <div className='d-flex flex-column zocks-gap-1.25 zocks-py-2.0 px-3 flex-grow-1'>
      <h3 className='text-center'>Hello, {currentUser?.firstName ?? 'there'}!</h3>
      <h3 className='zocks-text-gray-500 text-center'>How can I help you today?</h3>
      <div className='paragraph-medium text-center'>{introText}</div>
    </div>
  )
}
